<template>
  <v-text-field
      :error-messages="error"
      :label="isPasswordConfirmation ?
      translation(translationList.password_confirmation, 'Confirmare parola') : translation(translationList.password, 'Parola')"
      v-model="password"
      :rules="passwordValidationRules"
      name="password"
      variant="outlined"
      :tile="true"
      type="password"
  >
  </v-text-field>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, toRefs, watch} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    isPasswordConfirmation: Boolean as () => boolean | null,
  },
  setup(props, {emit}) {
    const {modelValue, isPasswordConfirmation} = toRefs(props);
    const password = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const passwordValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => (v && v.length >= 8) || translation(translationList.value.min_length, 'Password must be at least 8 characters long'),
    ];

    function validatePassword(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = passwordValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return passwordValidationRules.every(rule => rule(value) === true);
    }

    watch(password, (newValue) => {
      const isValid = validatePassword(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', '');
      }
      if (isPasswordConfirmation.value) {
        emit('validation-customer-status', {field: 'password_confirmation', isValid});
      } else {
        emit('validation-customer-status', {field: 'password', isValid});
      }
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validatePassword(password.value);
      if (isPasswordConfirmation.value) {
        emit('validation-customer-status', {field: 'password_confirmation', isValid});
      } else {
        emit('validation-customer-status', {field: 'password', isValid});
      }

      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === 'password') {
        const isValid = validatePassword(password.value, true);
        if (isValid) {
          if (isPasswordConfirmation) {
            emit('validation-customer-status', {field: 'password_confirmation', isValid});
          } else {
            emit('validation-customer-status', {field: 'password', isValid});
          }
        }
      }
    };

    return {
      password,
      passwordValidationRules,
      translationList,
      translation,
      error,
      isPasswordConfirmation
    };
  },
});
</script>

<style scoped>
</style>